import { fromJS } from 'immutable';
import api from 'src/api';
import { finish } from '../actions/subscription';

export function addBet(state, action) {
    const { id, bet, key } = action;

    return state.mergeIn([ 'items', key, id ], bet);
}

export function removeBet( state, { id, key } ) {
    return state.deleteIn( [ 'items', key, id ] );
}
